export class LoginError implements Error {
  public stack?: string;

  constructor(
    public message: string,
    public readonly name = 'LoginError',
  ) {}

  public get error(): string {
    return this.message;
  }
}

export class LoginWithPasswordError extends LoginError {
  public error_description?: string;
}
